// src/components/ProjectsCarousel.jsx
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; // ✅ only this (no slick-theme.css)
import "@fortawesome/fontawesome-free/css/all.min.css";

const projects = [
  { img: "/images/page-img/1.webp", title: "1 Sharing room", cat: "Architecture", href: "#" },
  { img: "/images/page-img/2.webp", title: "2 Sharing room", cat: "Engineering", href: "#" },
  { img: "/images/page-img/3.webp", title: "3 Sharing room", cat: "Consulting", href: "#" },
  ];

function NextArrow({ onClick }) {
  return (
    <button className="proj-arrow next" onClick={onClick} aria-label="Next">
      <i className="fas fa-chevron-right" />
    </button>
  );
}

function PrevArrow({ onClick }) {
  return (
    <button className="proj-arrow prev" onClick={onClick} aria-label="Previous">
      <i className="fas fa-chevron-left" />
    </button>
  );
}

export default function ProjectsCarousel() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 900, settings: { slidesToShow: 2 } },
      { breakpoint: 600, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section className="project-section-home">
      <div className="auto-container">
        <div className="sec-title style-two centered">
          <h2>
            Our <span>Projects</span>
          </h2>
          <div className="separator"></div>
        </div>

        <div className="projects-carousel">
          <Slider {...settings}>
            {projects.map((p, idx) => (
              <div className="item" key={idx}>
                <div>
                  <img src={p.img} alt={p.title} />
                </div>
                <div className="info">
                  <h3>
                    <a href={p.href}>{p.title}</a>
                  </h3>
                  {/* <h4>
                    <a href={p.href}>{p.cat}</a>
                  </h4> */}
                  <a href={p.href} aria-label="Open project">
                    <i className="fas fa-arrow-right"></i>
                  </a>
                </div>
              </div>
            ))}
          </Slider>
        </div>

        <br />
        <div className="text-center">
          <a href="/pg-room" className="theme-btn btn-style-one">
            More Room
          </a>
        </div>
      </div>
    </section>
  );
}
